<div class="map-container">
	<!-- <button mat-icon-button class="open-fullscreen max-z-index" (click)="handleFullscreenButtonPress()"><mat-icon>open_in_full</mat-icon></button> -->
	<!-- <button mat-icon-button class="open-fullscreen max-z-index" style="top: initial; bottom: 0" (click)="handleClearAllMarkers()"><mat-icon>delete</mat-icon></button> -->
	<div class="map-frame">
		<div id="map"></div>
	</div>
</div>
